import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-end justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-no-repeat bg-[#0b2240]"
        style={{
          backgroundImage:
            'url(https://storage.readdy-site.link/project_files/5a4bdf41-1aeb-4fa9-8af1-697cd10aa572/f2a9b94d-1bf0-4975-9c5a-496ed605e14b_Family.jpg?v=220b211723fceea6fa5578666a778480)',
          backgroundSize: '100% auto',
          backgroundPosition: 'center 20%',
        }}
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-black/70" />

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 pb-16 pt-0">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-4">
            Protecting Your Priorities
          </h1>
          <div className="w-20 h-1 bg-[#9cbde5] mx-auto my-6" />
          <h2 className="text-xl md:text-2xl text-white/90 font-light mb-10">
            Experience the difference with our independent insurance agency.
          </h2>
          <Link
            to="/about"
            className="inline-block border-2 border-white text-white hover:bg-white hover:text-[#0b2240] font-bold px-10 py-4 rounded-md transition-all duration-300 text-sm whitespace-nowrap"
          >
            Meet Our Team
          </Link>
        </div>
      </div>
    </section>
  );
}
